<!-- FOOTER -->
<footer class="site-footer" style="background-color: black">
  <div class="container">
    <div class="row align-items-center gy-3">
      <div class="col-md-4 text-center text-md-start">
        <a class="d-inline-flex align-items-center text-decoration-none" routerLink="/landing-page">
          <img
            src="/assets/images/landing-page/Khaos_Software_Solutions_Logo_Only_Black.svg"
            alt="Khaos logo"
            class="brand-logo me-2"
          />
          <span class="company-name">Khaos Software Solutions</span>
        </a>
        <!-- <div class="mt-2 text-muted small">Compliance & Inventory tools for dealers</div> -->
      </div>

      <div class="col-md-4">
        <!-- <ul class="footer-links list-unstyled d-flex justify-content-center mb-0">
          <li><a href="#" class="text-muted">Home</a></li>
          <li><a href="#" class="text-muted ms-3">Contact</a></li>
          <li><a href="#" class="text-muted ms-3">Service Plans</a></li>
          <li><a href="#" class="text-muted ms-3">About</a></li>
          <li><a href="#" class="text-muted ms-3">Login</a></li>
        </ul> -->
      </div>

      <div class="col-md-4 text-center text-md-end">
        <div class="small text-white">©2025  Khaos Software Solutions</div>
        <!-- <div class="social mt-2">
          <a class="text-muted ms-2" href="#" aria-label="Twitter">T</a>
          <a class="text-muted ms-2" href="#" aria-label="LinkedIn">L</a>
        </div> -->
      </div>
    </div>
  </div>
</footer>
